import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html',
  standalone: true
})
export class ExternalRedirectComponent implements OnInit {
  constructor(private readonly route: ActivatedRoute) {}

  public ngOnInit(): void {
    const externalUrl = this.route.snapshot.queryParamMap.get('externalUrl') as string;
    window.open(externalUrl, '_self');
  }
}
